/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFriendEntryResponse } from './IFriendEntryResponse';
import {
    IFriendEntryResponseFromJSON,
    IFriendEntryResponseFromJSONTyped,
    IFriendEntryResponseToJSON,
    IFriendEntryResponseToJSONTyped,
} from './IFriendEntryResponse';

/**
 * 
 * @export
 * @interface UpdateFriendLabelResponse
 */
export interface UpdateFriendLabelResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFriendLabelResponse
     */
    success: boolean;
    /**
     * 
     * @type {IFriendEntryResponse}
     * @memberof UpdateFriendLabelResponse
     */
    friend: IFriendEntryResponse;
}

/**
 * Check if a given object implements the UpdateFriendLabelResponse interface.
 */
export function instanceOfUpdateFriendLabelResponse(value: object): value is UpdateFriendLabelResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('friend' in value) || value['friend'] === undefined) return false;
    return true;
}

export function UpdateFriendLabelResponseFromJSON(json: any): UpdateFriendLabelResponse {
    return UpdateFriendLabelResponseFromJSONTyped(json, false);
}

export function UpdateFriendLabelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFriendLabelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'friend': IFriendEntryResponseFromJSON(json['friend']),
    };
}

export function UpdateFriendLabelResponseToJSON(json: any): UpdateFriendLabelResponse {
    return UpdateFriendLabelResponseToJSONTyped(json, false);
}

export function UpdateFriendLabelResponseToJSONTyped(value?: UpdateFriendLabelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'friend': IFriendEntryResponseToJSON(value['friend']),
    };
}

